import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import OverlayTooltip from '../common/UI/OverlayTooltip';
import BrandAgentIcon from '../../assets/icon-brand-agent.svg?react';
import BrandAgentPreferences from './BrandAgentPreferences';
import useElysiaStore from '@/app/elysia-store';

interface BrandAgentModalProps {
  initiated: boolean;
  setInitiated: (boolean) => void;
}
const BrandAgentModal = ({ initiated, setInitiated }: BrandAgentModalProps) => {
  const appKey = useElysiaStore((state) => state.appKey);

  const setChatAgent = useElysiaStore.getState().setChatAgent;

  const [isBrandModalOpen, setIsBrandModalOpen] = useState<boolean>(false);
  const [canSave, setCanSave] = useState<boolean>(false);
  const [savePreferences, setSavePreferences] = useState<boolean>(false);

  useEffect(() => {
    if (initiated) {
      setIsBrandModalOpen(true);
    }
  }, [initiated]);

  const handleClose = () => {
    setIsBrandModalOpen(false);
    setInitiated(false);
  };

  const handleModalClick = () => {
    setInitiated(true);
    setIsBrandModalOpen(true);
    setSavePreferences(false);
  };

  const handleSave = () => {
    setSavePreferences(true);
    setChatAgent?.('app-agent');
  };
  return (
    <>
      <OverlayTooltip
        tooltipText="Brand App"
        buttonContent={<BrandAgentIcon />}
        ariaLabel="brand app"
        testId="brand-agent"
        tooltipClassName="tooltip-sidebar"
        buttonClassName={`brand-agent ${appKey === 'brand_agent' ? 'selected' : ''}`}
        placement="top-start"
        onClick={handleModalClick}
      />
      {isBrandModalOpen && (
        <Modal
          show={isBrandModalOpen}
          onHide={handleClose}
          aria-label="Brand App Modal"
          dialogClassName="elysia-modal custom-modal"
          className="brand-agent-modal"
          backdropClassName="custom-backdrop"
          centered
          id="brand-agent-modal"
        >
          <Modal.Header closeButton>
            <div>
              <Modal.Title data-testid="brand-agent-header">Brand App</Modal.Title>
            </div>
          </Modal.Header>
          <Modal.Body className="pt-2">
            <div>
              <span>Please select the options below to update the conversation.</span>
            </div>
            <div>
              <BrandAgentPreferences
                savePreferences={savePreferences}
                setCanSave={setCanSave}
                handleClose={handleClose}
              />
              <Button
                disabled={!canSave}
                onClick={handleSave}
                data-testid="update-button"
                variant="secondary"
              >
                Update
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default BrandAgentModal;
